import { styled } from '../../Styles/stitches.config'
import { StyledButton } from '../Button'
import { StyledSVG } from '../SVG/styles'

export const StyledIcon = styled('div', {
    display: 'flex',
    position: 'absolute',
    right: '16px',
    top: '50%',
    transform: 'translateY(-50%)',
    transition: '$default',

    [`& ${StyledSVG}`]: {
        alignContent: 'center',
        size: 24,
    },

    variants: {
        active: {
            true: {
                color: '$primary600',
            },
            false: {
                color: 'transparent',
            },
        },
    },
})

export const StyledSelectButton = styled(StyledButton, {
    position: 'relative',
    justifyContent: 'start',
    w: '100%',
})
